<template>
  <b-modal ref="modal" hide-footer title="Qualifier callback" size="lg">
        <div class="label">Callback Date</div>
        <div class="text">
          <b-form-datepicker
            v-model="selectedDate"
            class="mb-2"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
            }"
            locale="en-GB"
          ></b-form-datepicker>
        </div>

        <div class="label">Callback Time</div>
        <div class="text">
          <b-form-select v-model="selectedCallbackTime" :options="callbackTime">
          </b-form-select>
        </div>

        <div class="label">Callback Priority</div>
        <div class="text">
          <b-form-select
            v-model="selectedPriority"
            :options="priorities"
          ></b-form-select>
        </div>

        <div>
          <b-button
            class="mt-3"
            variant="success"
            block
            @click="saveCallback"
            :disabled="!isValid()"
          >
            <font-awesome-icon icon="check" /> Confirm
          </b-button>

          <b-button
            class="mt-3"
            variant="danger"
            block
            @click="cancel"
          >
            <font-awesome-icon icon="times" /> Cancel
          </b-button>
        </div>
  </b-modal>
</template>

<!--
  a.	Will need a new call back type called: Randd Lead Gen which is automatically set and not changeable 
b.	User can select a date and time for the callback
c.	Status should change to callback if not already (but not overwrite unbooked etc) the usual logic.
Callback is for the qualifier - type set on server side - only date here? maybe priority
-->

<script>
  export default {
    data() {
      return {
        selectedCallbackTime: null,
        selectedPriority: null,
        selectedDate: null,
        priorities: [
          { value: null, text: "Select Priority", disabled: true },
          { value: "10", text: "Low" },
          { value: "20", text: "Medium" },
          { value: "30", text: "High" },
        ],
        callbackTime: [
          { value: null, text: "Select Time", disabled: true },
          { value: "08:00", text: "8:00 AM" },
          { value: "08:15", text: "8:15 AM" },
          { value: "08:30", text: "8:30 AM" },
          { value: "08:45", text: "8:45 AM" },
          { value: "09:00", text: "9:00 AM" },
          { value: "09:15", text: "9:15 AM" },
          { value: "09:30", text: "9:30 AM" },
          { value: "09:45", text: "9:45 AM" },
          { value: "10:00", text: "10:00 AM" },
          { value: "10:15", text: "10:15 AM" },
          { value: "10:30", text: "10:30 AM" },
          { value: "10:45", text: "10:45 AM" },
          { value: "11:00", text: "11:00 AM" },
          { value: "11:15", text: "11:15 AM" },
          { value: "11:30", text: "11:30 AM" },
          { value: "11:45", text: "11:45 AM" },
          { value: "12:00", text: "12:00 PM" },
          { value: "12:15", text: "12:15 PM" },
          { value: "12:30", text: "12:30 PM" },
          { value: "12:45", text: "12:45 PM" },
          { value: "13:00", text: "1:00 PM" },
          { value: "13:15", text: "1:15 PM" },
          { value: "13:30", text: "1:30 PM" },
          { value: "13:45", text: "1:45 PM" },
          { value: "14:00", text: "2:00 PM" },
          { value: "14:15", text: "2:15 PM" },
          { value: "14:30", text: "2:30 PM" },
          { value: "14:45", text: "2:45 PM" },
          { value: "15:00", text: "3:00 PM" },
          { value: "15:15", text: "3:15 PM" },
          { value: "15:30", text: "3:30 PM" },
          { value: "15:45", text: "3:45 PM" },
          { value: "16:00", text: "4:00 PM" },
          { value: "16:15", text: "4:15 PM" },
          { value: "16:30", text: "4:30 PM" },
          { value: "16:45", text: "4:45 PM" },
          { value: "17:00", text: "5:00 PM" },
          { value: "17:15", text: "5:15 PM" },
          { value: "17:30", text: "5:30 PM" },
          { value: "17:45", text: "5:45 PM" },
          { value: "18:00", text: "6:00 PM" },
          { value: "18:15", text: "6:15 PM" },
          { value: "18:30", text: "6:30 PM" },
          { value: "18:45", text: "6:45 PM" },
          { value: "19:00", text: "7:00 PM" },
          { value: "19:15", text: "7:15 PM" },
          { value: "19:30", text: "7:30 PM" },
          { value: "19:45", text: "7:45 PM" },
          { value: "20:00", text: "8:00 PM" },
          { value: "20:15", text: "8:15 PM" },
          { value: "20:30", text: "8:30 PM" },
          { value: "20:45", text: "8:45 PM" },
          { value: "21:00", text: "9:00 PM" },
        ]
      };
    },
    methods: {
      showModal() {
        this.$refs["modal"].show();
      },
      hideModal() {
        this.$refs["modal"].hide();
      },
      saveCallback() {
        this.$parent.submitWithCallback(this.selectedDate, this.selectedCallbackTime, this.selectedPriority);
        this.clear();
        this.hideModal();
      },
      clear() {
        this.selectedDate = null;
        this.selectedCallbackTime = null;
        this.selectedPriority = null;
      },
      cancel() {
        this.clear();
        this.$refs["modal"].hide();
      },
      isValid() {
        if (!this.selectedDate) return false;
        if (!this.selectedCallbackTime) return false;
        if (!this.selectedPriority) return false;  
        return true;
      }
    }
  }
</script>
